module.exports = __webpack_public_path__ + "img/logo@2x.52b40aa0.png";